export const TAB_ORIENTATIONS = {
    HORIZONTAL: 'horizontal',
    VERTICAL: 'vertical',
};
export const TAB_SIZES = {
    DEFAULT: 'default',
    SMALL: 'small',
};
export const TAB_KINDS = {
    DEFAULT: 'default',
    GHOST: 'ghost',
};
